import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import config from '../../config';

const HEADERS = {
    headers: {
        'x-api-key': config.API_KEY
    }
}

const Api = {
    init() {
        Vue.use(VueAxios, axios);
        axios.defaults.baseURL = config.API_URL;
    },

    query(resource, params) {
        return axios.get(resource, params, HEADERS).catch(error => {
            throw new Error(`[WAKATOON] Api ${error}`);
        });
    },

    get(resource) {
        return axios.get(resource, HEADERS).catch(error => {
            throw new Error(`[WAKATOON] Api ${error}`);
        });
    },

    post(resource, params) {
        return axios.post(resource, params, HEADERS);
    },

    put(resource, params) {
        return axios.put(resource, params, HEADERS);
    },

    delete(resource) {
        return axios.delete(resource, HEADERS).catch(error => {
            throw new Error(`[WAKATOON] Api ${error}`);
        });
    }
};

export default Api;